export default __webpack_public_path__ + "static/media/ic_gibraltar.212cc8f0.svg";